import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getAPI, reinitialiseAPI } from 'store/apiReducer';
import BoutonFichierTelechargeable from 'components/Commun/Fichier/BoutonFichierTelechargeable';
import PropTypes from 'prop-types';
import {
    API_RECUPERER_FICHIER_TELECHARGEMENT,
    CONTEXT_API_RECUPERER_FICHIER_TELECHARGEMENT,
} from '../../constants/apiUrls.constants';
import usagerClientReducer from '../../store/usagerReducer';

const BoutonTelechargementFichier = ({
    uuidFichier,
    getApi,
    reinitialiseApi,
    dataFichierTelechargement,
    isLoading,
    libelle,
    disableLoader,
    ...otherProps
}) => {
    const [activeFile, setActiveFile] = useState(false);

    const telechargementFichier = () => {
        setActiveFile(true);
        getApi(
            usagerClientReducer,
            API_RECUPERER_FICHIER_TELECHARGEMENT + uuidFichier,
            CONTEXT_API_RECUPERER_FICHIER_TELECHARGEMENT,
        );
    };

    const onDownload = () => {
        setActiveFile(false);
        reinitialiseApi(API_RECUPERER_FICHIER_TELECHARGEMENT);
    };

    return (
        <BoutonFichierTelechargeable
            handleOnClick={telechargementFichier}
            label={libelle}
            titreFichier={
                activeFile && dataFichierTelechargement
                    ? dataFichierTelechargement.libelleUtilisateur
                    : null
            }
            mimeType={
                activeFile && dataFichierTelechargement
                    ? dataFichierTelechargement.mimeTypeFichier
                    : null
            }
            contenu={
                activeFile && dataFichierTelechargement
                    ? dataFichierTelechargement.contenuFichier
                    : null
            }
            isLoading={!disableLoader && isLoading && activeFile}
            callBack={onDownload}
            {...otherProps}
        />
    );
};

BoutonTelechargementFichier.propTypes = {
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    disableLoader: PropTypes.bool,
    uuidFichier: PropTypes.string.isRequired,
    dataFichierTelechargement: PropTypes.shape({
        libelleUtilisateur: PropTypes.string.isRequired,
        contenuFichier: PropTypes.string.isRequired,
        mimeTypeFichier: PropTypes.string.isRequired,
    }),
    isLoading: PropTypes.bool,
    libelle: PropTypes.string.isRequired,
};

BoutonTelechargementFichier.defaultProps = {
    disableLoader: false,
};

export default connect(
    (state) => {
        const { isLoading, data, erreur, message } = state.fichier.fichierTelechargement;
        return {
            isLoading,
            dataFichierTelechargement: data,
            erreur,
            message,
        };
    },
    {
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(BoutonTelechargementFichier);
